function toCamelCase(str: string): string {
  if (!str) return str
  return str.charAt(0).toLowerCase() + str.slice(1).replace(/ID/g, 'Id')
}

export class UserPreferences {
  clientRows: number | null
  clientSortField: string
  clientSortDir: 'asc' | 'desc'
  customTransactionLinkDaysBack?: number | null
  customTransactionLinkStatus?: number | null
  highLightTransactionsPendingAlerts?: boolean | null
  pendingRows: number
  pendingSortField: string
  pendingSortDir: 'asc' | 'desc'
  transactionRows: number
  transactionSortField: string
  transactionSortDir: 'asc' | 'desc'
  userId: string
  userPreferenceId: number

  constructor(data: UserPreferencesDB) {
    this.clientRows = data.clientRows
    this.clientSortField = toCamelCase(data.clientSort.split(' ')[0])
    this.clientSortDir = data.clientSort.split(' ')[1] as 'asc' | 'desc'
    this.customTransactionLinkDaysBack = data.custoTransactionmLinkDaysBack
    this.customTransactionLinkStatus = data.customTransactionLinkStatus
    this.highLightTransactionsPendingAlerts =
      data.highLightTransactionsPendingAlerts
    this.pendingRows = data.pendingRows
    this.pendingSortField = toCamelCase(data.pendingSort.split(' ')[0])
    this.pendingSortDir = data.pendingSort.split(' ')[1] as 'asc' | 'desc'
    this.transactionRows = data.transactionRows
    this.transactionSortField = toCamelCase(data.transactionSort.split(' ')[0])
    this.transactionSortDir = data.transactionSort.split(' ')[1] as
      | 'asc'
      | 'desc'
    this.userId = data.userId
    this.userPreferenceId = data.userPreferenceId
  }
}

export class UserPreferencesDB {
  clientRows: number | null
  clientSort: string
  custoTransactionmLinkDaysBack: number | null
  customTransactionLinkStatus: number | null
  highLightTransactionsPendingAlerts: boolean | null
  pendingRows: number
  pendingSort: string
  transactionRows: number
  transactionSort: string
  userId: string
  userPreferenceId: number

  constructor(data: UserPreferences) {
    this.clientRows = data.clientRows
    this.clientSort = data.clientSortField + ' ' + data.clientSortDir
    this.custoTransactionmLinkDaysBack = data.customTransactionLinkDaysBack
    this.customTransactionLinkStatus = data.customTransactionLinkStatus
    this.highLightTransactionsPendingAlerts =
      data.highLightTransactionsPendingAlerts
    this.pendingRows = data.pendingRows
    this.pendingSort = data.pendingSortField + ' ' + data.pendingSortDir
    this.transactionRows = data.transactionRows
    this.transactionSort =
      data.transactionSortField + ' ' + data.transactionSortDir
    this.userId = data.userId
    this.userPreferenceId = data.userPreferenceId
  }
}
